export const useTitle = () => {
  const setTitle = (title: string) => {
    document.title = `${title} \u00B7 Lilasia`
  }

  return { setTitle }
}
